module.exports = __webpack_public_path__ + "img/cg.7b7c6ebc.svg";